<template>
  <div>
    <v-btn icon small color="primary">
      <v-icon @click="download">mdi-download</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  methods: {
    download() {
      let data = this.params.data;
      this.params.clicked(data.fileName);
    },
  },
});
</script>
